import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";

import AppointmentsInfoSelector from "../AppointmentsInfoSelector/AppointmentsInfoSelector";
import {
    updateNewAppointment,
    updateExistAppointment,
} from "@/store/appointments/appointmentsSlice";
import { RootState } from "@/store/store";
import Title from "@/shared/components/Title/Title";
import PatientBlock from "./PatientBlock";
import DoctorBlock from "./DoctorBlock";

import { ISearchDrawerProps } from "@/shared/interfaces/ui";

import "./AppointmentsInfoSection.scss";

export default function AppointmentsInfoSection({
    toggleDrawer,
}: ISearchDrawerProps) {
    const dispatch = useDispatch();
    const appointmentData = useSelector(
        (state: RootState) => state.appointments.existtAppointment,
    );

    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );
    const errors = useSelector((state: RootState) => state.ui.errors);
    const { patientId, doctorId, notes, isAppointmentComplete } =
        appointmentData;
    const [localNotes, setLocalNotes] = useState(
        isEditAppointment ? notes : "",
    );
    const patientName = patientId?.name || "Дані про пацієнта відсутні";
    const doctorName = doctorId?.name || "Дані про лікаря відсутні";

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const updatePayload = { notes: localNotes };
            if (!isEditAppointment) {
                dispatch(updateNewAppointment(updatePayload));
            } else {
                dispatch(updateExistAppointment(updatePayload));
            }
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [localNotes, dispatch, isEditAppointment]);

    return (
        <div className='appointment_left_part_client_info'>
            <Title tag='h3' text={"Інформація"} />
            <PatientBlock
                toggleDrawer={toggleDrawer}
                isAppointmentComplete={isAppointmentComplete}
            />
            {errors?.patientName && patientName.length === 0 && (
                <p className='error_message'>{errors?.patientName?.message}</p>
            )}
            <AppointmentsInfoSelector
                isAppointmentComplete={isAppointmentComplete}
            />
            <DoctorBlock
                toggleDrawer={toggleDrawer}
                isAppointmentComplete={isAppointmentComplete}
            />
            {errors?.doctorName && doctorName.length === 0 && (
                <p className='error_message'>{errors?.doctorName?.message}</p>
            )}
            <input
                placeholder='Примітки'
                className='appointment_selector input_selector'
                onChange={e => setLocalNotes(e.target.value)}
                value={localNotes}
                maxLength={200}
                disabled={isAppointmentComplete}
            />
        </div>
    );
}
